import { createCrudContext } from "./_lib/createCrudContext";

const { Provider, useValue } = createCrudContext({
  name: "agent",
  listPath: "dosee/agent",
  adminPath: "dosee/agent",
  legacy: {
    data: "agent",
    count: "count",
    fetch: "fetchAgents",
    create: "createOneAgent",
    update: "updateAgent",
    remove: "deleteAgent",
    updateState: "updateAgentState",
  },
});

export const AgentProvider = Provider;
export const useAgentContext = useValue;
